/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Sections components

// Avatars page components

// Avatars page components code

import { useParams } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import MKBox from "../../components/MKBox";
import GridCardAssetsData from "../../views/GridCard/GridCardAssetsData";
import GridCardLayersData from "../../views/GridCard/GridCardLayersData";
import GridCardMapData from "../../views/GridCard/GridCardMapData";
import GridCardSelectData from "../../views/GridCard/GridCardSelectData";
import MainLayout from "../MainLayout";
import HTTP_API from "../../store/constant/httpApi";

function DataView() {
  const { proID } = useParams();

  const [BreadcrumbsRoutes, setBreadcrumbsRoutes] = useState([
    { label: "Home", route: "/home" },
    { label: "Data", route: "/data" },
  ]);

  const [loading, setLoading] = useState(true);
  const [collection, setCollection] = useState(null);

  const mapRef = useRef();
  const [map, setMap] = useState(null);

  useEffect(() => {
    axios
      .get(`${HTTP_API.STAC}/collections/${proID}`)
      .then((response) => {
        setCollection(response.data);
        setLoading(false);
        setBreadcrumbsRoutes([
          { label: "Home", route: "/home" },
          { label: "Data", route: "/data" },
          { label: response.data.title },
        ]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox component="section">
        <MKBox width="100%" pt={0.1} bgColor="white">
          {loading ? (
            <MKBox sx={{ display: "flex" }}>
              <CircularProgress />
            </MKBox>
          ) : (
            <Grid2 container justifyContent="space-evenly" sx={{ height: 1, width: 1 }}>
              <Grid2
                container
                xs={12}
                md={4}
                lg={2.5}
                xxl={2.25}
                xxxl={1.75}
                xxxxl={1.5}
                justifyContent="space-evenly"
              >
                <Grid2 xs={6} md={12} sx={{ height: { xs: "1", md: "0.5" } }} p={1}>
                  <GridCardSelectData productionInfo={collection} map={map} />
                </Grid2>
                <Grid2 xs={6} md={12} sx={{ height: { xs: "1", md: "0.5" } }} p={1}>
                  <GridCardLayersData productionInfo={collection} map={map} />
                </Grid2>
              </Grid2>
              <Grid2 xs={12} md={4} lg={6.5} xxl={7.25} xxxl={8.25} xxxxl={8.5} p={1}>
                <GridCardMapData
                  productionInfo={collection}
                  map={map}
                  mapRef={mapRef}
                  setMap={setMap}
                  className="ol-map-high"
                />
              </Grid2>
              <Grid2
                container
                xs={12}
                md={4}
                lg={3}
                xxl={2.5}
                xxxl={2}
                xxxxl={2}
                justifyContent="space-evenly"
              >
                <Grid2 xs={6} md={12} sx={{ height: 1 }} p={1}>
                  <GridCardAssetsData map={map} />
                </Grid2>
              </Grid2>
            </Grid2>
          )}
        </MKBox>
      </MKBox>
    </MainLayout>
  );
}

export default DataView;
